import { render, staticRenderFns } from "./FormReportAccess.vue?vue&type=template&id=ee27c4f2"
import script from "./FormReportAccess.vue?vue&type=script&lang=js"
export * from "./FormReportAccess.vue?vue&type=script&lang=js"
import style0 from "./FormReportAccess.vue?vue&type=style&index=0&id=ee27c4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports